import { createIcon } from '@chakra-ui/react';

export const ReportBoldIcon = createIcon({
  displayName: 'ReportBoldIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="16"
        // height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          d="M14 15.6665H2C1.72667 15.6665 1.5 15.4398 1.5 15.1665C1.5 14.8932 1.72667 14.6665 2 14.6665H14C14.2733 14.6665 14.5 14.8932 14.5 15.1665C14.5 15.4398 14.2733 15.6665 14 15.6665Z"
          fill="#2B2448"
        />
        <path
          d="M3.73333 6.08643H2.66667C2.3 6.08643 2 6.38643 2 6.75309V12.4998C2 12.8664 2.3 13.1664 2.66667 13.1664H3.73333C4.1 13.1664 4.4 12.8664 4.4 12.4998V6.75309C4.4 6.37976 4.1 6.08643 3.73333 6.08643Z"
          fill="#2B2448"
        />
        <path
          d="M8.53314 3.95996H7.46647C7.0998 3.95996 6.7998 4.25996 6.7998 4.62663V12.5C6.7998 12.8666 7.0998 13.1666 7.46647 13.1666H8.53314C8.89981 13.1666 9.19981 12.8666 9.19981 12.5V4.62663C9.19981 4.25996 8.89981 3.95996 8.53314 3.95996Z"
          fill="#2B2448"
        />
        <path
          d="M13.3329 1.8335H12.2663C11.8996 1.8335 11.5996 2.1335 11.5996 2.50016V12.5002C11.5996 12.8668 11.8996 13.1668 12.2663 13.1668H13.3329C13.6996 13.1668 13.9996 12.8668 13.9996 12.5002V2.50016C13.9996 2.1335 13.6996 1.8335 13.3329 1.8335Z"
          fill="#2B2448"
        />
      </svg>
    </>
  ),
});
